export const colors = {
  black_scales: {
    full_black: '#000',
    black_opacity_05: 'rgba(0,0,0,0.5)',
  },
  white_scales: {
    white: '#FFFFFF',
    pinkish_white: '#F0F0F0',
  },
  yellow_scales: {
    yellow_dark: '#FFB411',
    greenish_yellow: '#FCFFEB',
  },
  blue_scales: {
    cyan_blue_dark: '#171819',
    cyan_blue_mid: '#5F6163',
    cyan_blue_dark_2: '#232425',
    medium_dark_cyan_blue: '#454647',
    blue_dark: '#2970FF',
    sort_blue: 'rgba(136, 169, 255, 0.20)',
    dark_blue: '#4A69F7',
    light_blue: '#88A9FF',
    blue_sky: '#30A8FF',
    light_medium_blue: '#5987FF',
    midnight_blue: '#071E29',
    aqua: '#4EF7EF',
    aqua_opacity_01: 'rgba(89, 135, 255, 0.10)',
  },
  gray_scales: {
    gray_super_dark: '#131415',
    grayish_dark: '#1C1C1C',
    opaque_gray: '#AAAEB1',
    grayish_white: '#EEEEF2',
    light_gray: '#DCDCDC',
    transparent_gray_008: 'rgba(255, 255, 255, 0.08)',
    transparent_gray_01: 'rgba(255, 255, 255, 0.10)',
    transparent_gray_02: 'rgba(255, 255, 255, 0.20)',
    transparent_gray_03: 'rgba(255, 255, 255, 0.30)',
    transparent_gray_04: 'rgba(255, 255, 255, 0.40)',
    transparent_gray_07: 'rgba(255, 255, 255, 0.70)',
  },
  green_scales: {
    cyan_green: '#0CCF7D',
    cyan_green_mid: '#3CCB7E',
    medium_green: '#32E970',
    light_green_mid_2: '#60FAA7',
    cyan_green_dark: '#00CF46',
    cyan_green_dark_2: '#00DB4B',
    forest_green: '#034938',
    transparent_green: 'rgba(25, 151, 98, 0.10)',
    transparent_green_05: 'rgba(1, 223, 174, 0.05)',
    transparent_green_light: 'rgba(0, 207, 70, 0.10)',
  },
  red_scales: {
    pinkish_red: '#F32C3E',
    transparent_red: 'rgba(243, 44, 62, 0.20)',
    transparent_red_light: 'rgba(166, 0, 0, 0.30)',
    additional_red: '#FF4959',
    sort_red: 'rgba(255, 73, 89, 0.15)',
  },
  orange_scales: {
    orange: '#F7931A',
    sort_orange: 'rgba(247, 147, 26, 0.20)',
  },
  purple_scales: {
    purple: '#7059FF',
    medium_purple: '#7866FF',
    medium_purple_02: 'rgba(120, 102, 255, 0.20)',
    dark_purple: '#7361FF',
    bluish_purple: '#4732FF',
    light_purple: '#7B91FF',
    soft_purple: '#8171FF',
    vivid_purple: '#7D32FF',
    bluish_purple_02: 'rgba(71, 50, 255, 0.20)',
  },
}
